import colors from "@digits-shared/themes/colors"
import styled, { css } from "styled-components"
import customKeyframes from "src/shared/config/customKeyframes"

export const WORKITEM_DISMISSED = "work-item-dismissed"
export const WORKITEM_ACCEPTED = "work-item-accepted"
export const WORKITEM_CLOSED = "work-item-closed"
export const WORKITEM_REOPENED = "work-item-reopened"

export const UNKNOWN_PARTY = "Missing Vendor"
export const UNKNOWN_CATEGORY = "No Category"
export const TRANSACTION_REVIEW_CLASS_NAME = "transaction-review"
export const TRANSACTION_REVIEW_HEIGHT = 174

/*
  STYLES
*/

export const WorkItemRowContainer = styled.div<{
  dismissRow?: boolean
  hideRow?: boolean
}>`
  position: relative;
  padding-bottom: 15px;
`

export const Content = styled.div<{ addSelectedStyling?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 360px 1fr;

  &.${TRANSACTION_REVIEW_CLASS_NAME} {
    height: ${TRANSACTION_REVIEW_HEIGHT}px;
    width: calc(100% - 50px);
  }

  background: linear-gradient(
    112.77deg,
    rgba(255, 255, 255, 0.52) -3.3%,
    rgba(254, 254, 254, 0.1) 96.1%
  );

  border: 0.5px solid ${colors.white};
  border-radius: 20px;
  box-shadow: 0 0 24px rgba(139, 139, 139, 0.25);

  ${({ addSelectedStyling }) =>
    addSelectedStyling &&
    css`
      box-shadow: ${colors.accentBlue} 0 0 24px 0;
      border-color: ${colors.transparent};
    `}

  &.${WORKITEM_ACCEPTED} {
    transition:
      border-color 100ms,
      box-shadow 200ms;
    border-color: ${colors.neonGreen};
    box-shadow: 0 0 10px 2px ${colors.neonGreen};
    animation: ${customKeyframes.fadeOut} 500ms 200ms ease-out forwards;
  }

  &.${WORKITEM_DISMISSED} {
    animation: ${customKeyframes.fadeOut} 500ms 200ms ease-out forwards;
  }

  &.${WORKITEM_REOPENED} {
    animation: ${customKeyframes.fadeOutLeft} 500ms 250ms ease-out forwards;
  }

  &.${WORKITEM_CLOSED} {
    animation: ${customKeyframes.fadeOutRight} 500ms 250ms ease-out forwards;
  }
`

export const TransactionInfo = styled.div`
  flex: 1;
  padding: 20px 20px 20px 10px;

  &.${TRANSACTION_REVIEW_CLASS_NAME} {
    padding: 10px 15px 10px 10px;
  }
`

export const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: rgba(247, 249, 248, 1);
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;

  &.${TRANSACTION_REVIEW_CLASS_NAME} {
    align-items: flex-start;
  }
`

export const DetailsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px 0 25px;
  min-height: 90px;
`
